import toolkitObject from '@/tools/toolkit'

export default ({ store }, inject) => {
  if (process.browser) {
    return inject('toolkit', toolkitObject)
  }
}
